<template>
  <b-row>
    <b-col class="text-center">
      <slick :options="slickOptions">
        <router-link :to="route[i-1]" v-for="i in bannerImgUrl.length" :key="i">
          <img :src="bannerImgUrl[i-1]" alt />
        </router-link>
      </slick>
    </b-col>
  </b-row>
</template>

<script>
import Slick from "vue-slick";
import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";

export default {
  name: "BannerCarousel",
  components: {
    Slick,
  },
  props: {
    bannerImgUrl: Array,
    route: Array,
  },
  data() {
    return {
      slickOptions: {
        slidesToShow: 1,
         arrows: false,
        infinite: true,
        dots: true,
      },
    };
  },
};
</script>

<style scoped>
img {
  width: 100%;
  object-fit: contain;
  object-position: center center;
  /* max-height: 100%; */
}
</style>